import { toast } from '@/view/components/ui/use-toast'
import { TrainingFormValues } from '@/view/pages/Conteudos/hooks/useTrainingForm'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { trainingService } from '../services/trainingService'

export const useTrainingMutations = () => {
  const queryClient = useQueryClient()

  const createMutation = useMutation({
    mutationFn: (training: TrainingFormValues) =>
      trainingService.createTraining(training),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['trainings'] })
      toast({
        title: 'Treinamento criado com sucesso!',
      })
    },
    onError: () => {
      toast({
        variant: 'destructive',
        title: 'Erro ao criar treinamento. Tente novamente mais tarde.',
      })
    },
  })

  const updateMutation = useMutation({
    mutationFn: ({
      trainingId,
      training,
    }: {
      trainingId: string
      training: TrainingFormValues
    }) => trainingService.updateTraining(trainingId, training),
    onSuccess: (_, { trainingId }) => {
      queryClient.invalidateQueries({
        queryKey: ['training', trainingId],
        exact: false,
        refetchType: 'all',
      })
      queryClient.invalidateQueries({ queryKey: ['trainings'] })
      toast({
        title: 'Treinamento atualizado com sucesso!',
      })
    },
  })

  const deleteMutation = useMutation({
    mutationFn: (trainingId: string) =>
      trainingService.deleteTraining(trainingId),
    onSuccess: (_, trainingId) => {
      queryClient.invalidateQueries({
        queryKey: ['training', trainingId],
        exact: false,
        refetchType: 'all',
      })
      queryClient.invalidateQueries({ queryKey: ['trainings'] })
      toast({
        title: 'Treinamento deletado com sucesso!',
      })
    },
  })

  return {
    createTraining: createMutation.mutateAsync,
    isCreating: createMutation.isPending,
    updateTraining: updateMutation.mutateAsync,
    isUpdating: updateMutation.isPending,
    deleteTraining: deleteMutation.mutateAsync,
    isDeleting: deleteMutation.isPending,
  }
}
